import { render, staticRenderFns } from "./BusinessCapability.vue?vue&type=template&id=15fb20e9&scoped=true&"
import script from "./BusinessCapability.vue?vue&type=script&lang=js&"
export * from "./BusinessCapability.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCapability.vue?vue&type=style&index=0&id=15fb20e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fb20e9",
  null
  
)

export default component.exports